import { useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { ModeEco, ModeSleep } from '@/components/UI/svg/Wave2';
import NextImage from '@/components/NextImage';

enum Mode {
    eco,
    sleep,
}

const map: any = {
    us: 'us',
    ca: 'ca',
    cn: 'cn',
    de: 'de',
    fr: 'fr',
    kr: 'kr',
    jp: 'jp',
    es: 'es',
    it: 'it',
};

const mode = {
    className: '',
    color: '#4d4d4d',
    color1: '#949494',
    video: '',
};

const eco = {
    className: 'active',
    color: '#1d9d70',
    color1: '#FFFFFF',
    video: 'section_k_eco.png',
};

const sleep = {
    className: 'active',
    color: '#5e5bf8',
    color1: '#FFFFFF',
    video: 'section_k_sleep.png',
};

export default function K() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('wave2portableairconditioner');
    const [modeEco, setModeEco] = useState(eco);
    const [modeSleep, setModeSleep] = useState(mode);
    const [modeAct, setModeAct] = useState(Mode.eco);

    // // 视频异步加载延迟资源
    // const [sources1, setSources1] = useState<string[] | null>(null);
    // const [sources2, setSources2] = useState<string[] | null>(null);

    const onChangeMode = (m: Mode) => {
        setModeAct(m);
        if (m === Mode.eco) {
            setModeEco(eco);
            setModeSleep(mode);
        } else {
            setModeEco(mode);
            setModeSleep(sleep);
        }
    };

    // useEffect(() => {
    //     AniContainer.create({
    //         syncFromTo: [[`.${css.wave2DetailK} .viewport-wrapper`, { opacity: 0 }, { opacity: 1 }]],
    //         triggerElement: `.${css.wave2DetailK} .viewport-wrapper`,
    //         triggerHook: 1,
    //         offset: '10%',
    //         duration: '20%',
    //         onLazyLoad: async () => {
    //             setSources1([
    //                 `/video/wave2/pc/section_k_eco_${temp_unit[locale] || temp_unit.ca}.webm`,
    //                 `/video/wave2/pc/section_k_eco_${temp_unit[locale] || temp_unit.ca}.mp4`,
    //             ]);
    //             setSources2([
    //                 `/video/wave2/pc/section_k_sleep_${temp_unit[locale] || temp_unit.ca}.webm`,
    //                 `/video/wave2/pc/section_k_sleep_${temp_unit[locale] || temp_unit.ca}.mp4`,
    //             ]);
    //         },
    //     });
    // }, []);

    return (
        <div className={`wave2-detail-K ${css.wave2DetailK}`}>
            <div className="viewport-wrapper">
                <div className="text-wrapper">
                    <p className="title">{t('detail.sectionK_title')}</p>
                    <p className="desc">{t('detail.sectionK_desc')}</p>
                    <div className="mode-list">
                        <div className={`mode eco ${modeEco.className}`} onClick={() => onChangeMode(Mode.eco)}>
                            <div className="icon">
                                <ModeEco width="56px" height="56px" color={modeEco.color} color1={modeEco.color1} />
                            </div>
                            <p className="text">
                                {t.rich('detail.sectionK_3', {
                                    line1: (text1: string) => <span className="text1">{text1} </span>,
                                    line2: (text2: string) => <span className="text2">{text2} </span>,
                                })}
                            </p>
                        </div>
                        <div className={`mode sleep ${modeSleep.className}`} onClick={() => onChangeMode(Mode.sleep)}>
                            <div className="icon">
                                <ModeSleep width="56px" height="56px" color={modeSleep.color} color1={modeSleep.color1} />
                            </div>
                            <p className="text">
                                {t.rich('detail.sectionK_4', {
                                    line1: (text1: string) => <span className="text1">{text1} </span>,
                                    line2: (text2: string) => <span className="text2">{text2} </span>,
                                })}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="img-wrapper">
                    {/* {modeAct === Mode.eco && <EFVideo sources={sources1} width="100%" height="100%" loop={false} showReplay />}
                    {modeAct === Mode.sleep && (
                        <EFVideo
                            sources={sources2}
                            width="100%"
                            height="100%"
                            // loop={false}
                            // showReplay
                        />
                    )} */}
                    {modeAct === Mode.eco && (
                        <>
                            <NextImage
                                webpSrc={require(`@publicLocal/wave2/detail/pc/k_eco_${map[locale] || map.ca}.webp`)}
                                src={require(`@publicLocal/wave2/detail/pc/k_eco_${map[locale] || map.ca}.jpg`)}
                                alt={t('detail.sectionK_title')}
                                aria-label={t('detail.sectionK_title')}
                            />
                        </>
                    )}
                    {modeAct === Mode.sleep && (
                        <>
                            <NextImage
                                webpSrc={require(`@publicLocal/wave2/detail/pc/k_sleep_${map[locale] || map.ca}.webp`)}
                                src={require(`@publicLocal/wave2/detail/pc/k_sleep_${map[locale] || map.ca}.jpg`)}
                                alt={t('detail.sectionK_title')}
                                aria-label={t('detail.sectionK_title')}
                            />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
